import { DASHBOARD_LINK } from '@components/Router/constants'
import { Octopus } from '@lib/icons'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '@/types'
import css from './styles.module.css'

export const ProjectAvatar: React.FC = () => {
  const ref = useRef<HTMLImageElement>(null)

  const authenticated = useSelector<AppState, boolean>(
    ({ auth }) => auth.authenticated
  )

  const avatar = useSelector(migrationProjectSelector.getProjectAvatar)

  const isEmbed = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.isEmbed
  )

  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const teamId = useSelector(migrationProjectSelector.getProjectTeamId)

  useEffect(() => {
    if (!ref) {
      return
    }

    const img = ref.current as HTMLImageElement

    if (img) {
      img.style.width = 'auto'
      img.style.opacity = '0'

      setTimeout(() => {
        img.style.width = `${Math.min(img.offsetWidth, 36)}px`
        img.style.opacity = '1'
      }, 500)
    }
  }, [avatar, ref])

  const getUrl = () => {
    if (isEmbed && projectId) {
      return { url: `/${projectId}`, target: '_blank' }
    }

    if (authenticated) {
      if (!teamId) {
        return { url: DASHBOARD_LINK }
      }

      return { url: `${DASHBOARD_LINK}/${teamId}` }
    }
  }

  const cursor = authenticated || isEmbed ? 'pointer' : 'default'

  return (
    <a
      href={getUrl()?.url}
      className={css.avatar}
      style={{ cursor }}
      id="logo"
      target={getUrl()?.target}
    >
      {avatar && (
        <img src={avatar} alt="project-avatar" id="project-avatar" ref={ref} />
      )}

      {!avatar && <Octopus size={36} />}
    </a>
  )
}
